// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"183":"information","302":"ad-account","594":"about","792":"main","883":"shop"}[chunkId] + "." + {"183":"ab2868f4","302":"8b32b29a","594":"8b828404","792":"4735ae67","883":"1a64194c"}[chunkId] + ".js";
};